module.exports = __webpack_public_path__ + "static/2-4541a9bc857d502662a1d4c18ef18c11.jpg";